import DocumentHeader from '@components/DocumentHeader';
import If from '@components/If';
import { LoadingWarren } from '@simplywallst/ui-core';
import { TileViewContainer, TileRow } from '@components/TileView';
import { Tile, TileColumn, TileLink } from '@components/Tile';
import { ROUTE_DEPRECATED_PUBLIC_PORTFOLIO } from '@/constants/routes';
import { slugify } from '@utilities/slugify';
import {
  getCloudflareImageUrl,
  getResponsiveImage,
} from '@/hooks/useCloudflareImage';
import { getMarketCoverFromCurrency } from '@/utilities/coverImages';
import { usePublicPortfolios } from '../../hooks/usePublicPortfolios';
import { useTracking } from 'react-tracking';
import { formatDistanceToNow } from 'date-fns';

const ExplorePortfolios = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
  });
  const { data, status } = usePublicPortfolios();
  return (
    <Track>
      <DocumentHeader
        title="Discover - Sample Portfolios"
        allowCrawlers={true}
      />
      {typeof data !== 'undefined' && (
        <TileViewContainer>
          <TileRow>
            {data.map((n, index) => {
              const { id, name, dateGenerated, currencyISO } = n;
              const formattedDateGenerated =
                dateGenerated === null
                  ? 'n/a'
                  : formatDistanceToNow(
                      typeof dateGenerated === 'number'
                        ? dateGenerated
                        : Number(dateGenerated.date)
                    );

              const imageUrl = getCloudflareImageUrl({
                src: getMarketCoverFromCurrency(currencyISO),
                width: 276,
                height: 188,
                fit: 'crop',
              });

              const responsiveImages = getResponsiveImage({
                src: getMarketCoverFromCurrency(currencyISO),
                breakpoints: [
                  { width: 276, height: 188, fit: 'crop' },
                  { width: 163, height: 90, fit: 'crop' },
                ],
              });

              return (
                <TileColumn col={6} colSm={4} colLg={3} key={id}>
                  <TileLink
                    noUnderline
                    inheritColor
                    to={{
                      type: ROUTE_DEPRECATED_PUBLIC_PORTFOLIO,
                      payload: { portfolioId: id, name: slugify(name) },
                    }}
                    onClick={() =>
                      trackEvent({
                        action: 'click',
                        subject: 'tile',
                        portfolioId: id,
                        index: index,
                      })
                    }
                  >
                    <Tile
                      name={name}
                      description={`Created: ${formattedDateGenerated}`}
                      currencyISO={currencyISO?.toLowerCase()}
                      coverImage={imageUrl}
                      coverImageSet={responsiveImages.srcSet}
                    />
                  </TileLink>
                </TileColumn>
              );
            })}
          </TileRow>
        </TileViewContainer>
      )}
      <If match={status === 'pending'}>
        <LoadingWarren width={70} />
      </If>
    </Track>
  );
};

export default ExplorePortfolios;
